module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Leistungen_Layer2.870cacc8.svg";